/**
 * A simple class that implements a Queue, meant for use
 * with the third party ad widgets.
 */

import { BaseThirdPartyAd } from './types';

export default class AdQueue<T extends BaseThirdPartyAd> {
    private ads: T[];
    constructor() {
        this.ads = [];
    }

    /**
     * adds ad to the queue
     */
    enqueue(ad: T): void {
        this.ads.push(ad);
    }

    /**
     * Removes an ad object from the queue
     * and returns it
     */
    dequeue(): T | undefined {
        return this.ads.shift();
    }

    /**
     * returns the ad in the front of
     * the adqueue without dequeue'ing it.
     */

    peek(): T | undefined {
        return this.ads[0];
    }

    /**
     * returns the current size of queue
     */
    size(): number {
        return this.ads.length;
    }
}
